import _asyncToGenerator from "/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
var fetchYextData = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(mainYextId, isFolder, limit) {
    var isMultiple, yextLiveApi, mapIds, folderIds, result;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            isMultiple = mainYextId.length > 1; // TODO: double check
            yextLiveApi = [];
            if (isMultiple) {
              mapIds = [];
              mainYextId.map(function (id, i) {
                mapIds.push("".concat(id.trim()));
                if ((i + 1) % 50 == 0) {
                  yextLiveApi.push("https://liveapi.yext.com/v2/accounts/me/entities?filter=%7B%22meta.id%22%3A%7B%22%24in%22%3A".concat(JSON.stringify(mapIds), "%7D%7D&limit=").concat(limit || 50, "&api_key=").concat(process.env.NEXT_PUBLIC_YEXT_API_KEY, "&v=20161012"));
                  mapIds = [];
                }
              });
              yextLiveApi.push("https://liveapi.yext.com/v2/accounts/me/entities?filter=%7B%22meta.id%22%3A%7B%22%24in%22%3A".concat(JSON.stringify(mapIds), "%7D%7D&limit=").concat(limit || 50, "&api_key=").concat(process.env.NEXT_PUBLIC_YEXT_API_KEY, "&v=20161012"));
              // get yext entities by mathing multiple Id's
            } else if (mainYextId && isFolder) {
              folderIds = mainYextId.map(function (id) {
                var idAsNum = parseInt(id);
                return idAsNum;
              }); // get entities by folder
              yextLiveApi.push("https://liveapi.yext.com/v2/accounts/me/entities?filter=%7B%20%22meta.folderId%22%3A%7B%22%24in%22%3A[".concat(folderIds, "]%7D%7D&limit=").concat(limit || 50, "&api_key=").concat(process.env.NEXT_PUBLIC_YEXT_API_KEY, "&v=20161012"));
            } else {
              // get a single entity
              yextLiveApi.push("https://liveapi.yext.com/v2/accounts/me/entities/".concat(mainYextId, "?api_key=").concat(process.env.NEXT_PUBLIC_YEXT_API_KEY, "&v=20161012"));
            }
            result = Promise.all(yextLiveApi.map( /*#__PURE__*/function () {
              var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(each) {
                var resultData, response, otherPageresult;
                return _regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        _context.next = 2;
                        return fetch(each, {
                          credentials: 'omit'
                        })["catch"](function (err) {
                          return console.error(err);
                        });
                      case 2:
                        resultData = _context.sent;
                        _context.next = 5;
                        return resultData.json()
                        // eslint-disable-next-line no-console
                        ["catch"](function (err) {
                          return console.error(err);
                        });
                      case 5:
                        response = _context.sent;
                        if (!(response.response && response.response.count && response.response.count > 50 && response.response.pageToken)) {
                          _context.next = 11;
                          break;
                        }
                        _context.next = 9;
                        return getData(["".concat(yextLiveApi, "&pageToken=").concat(response.response.pageToken)]);
                      case 9:
                        otherPageresult = _context.sent;
                        if (otherPageresult && otherPageresult.length > 0 && otherPageresult[0].entities) {
                          otherPageresult[0].entities.map(function (each) {
                            response.response.entities.push(each);
                          });
                        }
                      case 11:
                        return _context.abrupt("return", response.response);
                      case 12:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee);
              }));
              return function (_x4) {
                return _ref2.apply(this, arguments);
              };
            }())
            // eslint-disable-next-line no-console
            )["catch"](function (err) {
              return console.error(err);
            });
            return _context2.abrupt("return", result);
          case 5:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return function fetchYextData(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();
var parseYextData = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(mainYextId, isFolder, limit) {
    var data, singleData, entities;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return fetchYextData(mainYextId, isFolder, limit);
          case 2:
            data = _context3.sent;
            if (!(data && data.length > 0)) {
              _context3.next = 17;
              break;
            }
            if (!(data.length == 1)) {
              _context3.next = 12;
              break;
            }
            singleData = data[0];
            if (!singleData.entities) {
              _context3.next = 9;
              break;
            }
            singleData.entities = singleData.entities.sort(function (a, b) {
              return a.meta.id > b.meta.id ? 1 : -1;
            });
            return _context3.abrupt("return", {
              entities: singleData.entities
            });
          case 9:
            return _context3.abrupt("return", singleData);
          case 12:
            if (!(data.length > 1)) {
              _context3.next = 17;
              break;
            }
            entities = [];
            data.map(function (each) {
              each.entities && each.entities.map(function (eachEntity) {
                entities.push(eachEntity);
              });
            });
            entities = entities.sort(function (a, b) {
              return a.meta.id > b.meta.id ? 1 : -1;
            });
            return _context3.abrupt("return", {
              entities: entities
            });
          case 17:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return function parseYextData(_x5, _x6, _x7) {
    return _ref3.apply(this, arguments);
  };
}();
var getCorrectPath = function getCorrectPath(path) {
  var slugUrl = '/' + path;
  if (slugUrl === '//undefined') {
    return '/';
  }
  return slugUrl;
};
var getYextIdFromCurrentPage = function getYextIdFromCurrentPage(_ref4) {
  var _combinedData$one, _combinedData$one$ite, _combinedData$one$ite2, _combinedData$one$ite3, _combinedData$one$ite4, _combinedData$one$ite5, _combinedData$one$ite6;
  var path = _ref4.path,
    combinedData = _ref4.combinedData;
  var slugUrl = getCorrectPath(path);
  var contactInformation = combinedData === null || combinedData === void 0 ? void 0 : (_combinedData$one = combinedData.one) === null || _combinedData$one === void 0 ? void 0 : (_combinedData$one$ite = _combinedData$one.items[0]) === null || _combinedData$one$ite === void 0 ? void 0 : (_combinedData$one$ite2 = _combinedData$one$ite.sitePagesCollection) === null || _combinedData$one$ite2 === void 0 ? void 0 : (_combinedData$one$ite3 = _combinedData$one$ite2.items) === null || _combinedData$one$ite3 === void 0 ? void 0 : (_combinedData$one$ite4 = _combinedData$one$ite3.filter(function (item) {
    var updatedUrl = item.url.charAt(0) !== '/' ? '/' + item.url : item.url;
    return updatedUrl === slugUrl;
  })) === null || _combinedData$one$ite4 === void 0 ? void 0 : (_combinedData$one$ite5 = _combinedData$one$ite4[0]) === null || _combinedData$one$ite5 === void 0 ? void 0 : (_combinedData$one$ite6 = _combinedData$one$ite5.overrideContactInformation) === null || _combinedData$one$ite6 === void 0 ? void 0 : _combinedData$one$ite6.yextIds;
  return contactInformation;
};
var getAllYextID = function getAllYextID(siteData) {
  var _siteData$locationCon;
  if (!siteData) {
    return [];
  }
  var mainYextId = (siteData === null || siteData === void 0 ? void 0 : (_siteData$locationCon = siteData.locationContactInformation) === null || _siteData$locationCon === void 0 ? void 0 : _siteData$locationCon.yextIds) || [];
  return mainYextId;
};
export var getYextInfo = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(mainYextId) {
    var data;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return parseYextData(mainYextId);
          case 2:
            data = _context4.sent;
            return _context4.abrupt("return", data);
          case 4:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return function getYextInfo(_x8) {
    return _ref5.apply(this, arguments);
  };
}();
var organizeYextInfoData = function organizeYextInfoData(_ref6) {
  var _yextInfoData$entitie, _yextInfoData$entitie2, _yextInfoData$entitie3;
  var yextInfoData = _ref6.yextInfoData,
    contactInformation = _ref6.contactInformation;
  if (!contactInformation) {
    return yextInfoData;
  }
  var yextInfo = yextInfoData === null || yextInfoData === void 0 ? void 0 : (_yextInfoData$entitie = yextInfoData.entities) === null || _yextInfoData$entitie === void 0 ? void 0 : _yextInfoData$entitie.find(function (entity) {
    var _entity$meta, _entity$meta2;
    if (!(entity !== null && entity !== void 0 && (_entity$meta = entity.meta) !== null && _entity$meta !== void 0 && _entity$meta.id)) {
      return false;
    }
    return (entity === null || entity === void 0 ? void 0 : (_entity$meta2 = entity.meta) === null || _entity$meta2 === void 0 ? void 0 : _entity$meta2.id) === (contactInformation === null || contactInformation === void 0 ? void 0 : contactInformation[0]);
  });
  // Making emergency banner global for all locations
  if (yextInfoData !== null && yextInfoData !== void 0 && (_yextInfoData$entitie2 = yextInfoData.entities) !== null && _yextInfoData$entitie2 !== void 0 && (_yextInfoData$entitie3 = _yextInfoData$entitie2[0]) !== null && _yextInfoData$entitie3 !== void 0 && _yextInfoData$entitie3.c_websiteEmergencyBanner) {
    var _yextInfoData$entitie4, _yextInfoData$entitie5;
    yextInfo.c_websiteEmergencyBanner = yextInfoData === null || yextInfoData === void 0 ? void 0 : (_yextInfoData$entitie4 = yextInfoData.entities) === null || _yextInfoData$entitie4 === void 0 ? void 0 : (_yextInfoData$entitie5 = _yextInfoData$entitie4[0]) === null || _yextInfoData$entitie5 === void 0 ? void 0 : _yextInfoData$entitie5.c_websiteEmergencyBanner;
  }
  return yextInfo;
};

// If yextInfo doesn't exist, it fetches it and returns the data
export var getYext = /*#__PURE__*/function () {
  var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(_ref7) {
    var _siteCollectionData$s, _siteCollectionData$s2;
    var path, combinedData, siteCollectionData, _ref7$yextInfo, yextInfo, siteData, contactInformation, mainYextId, yextInfoData;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            path = _ref7.path, combinedData = _ref7.combinedData, siteCollectionData = _ref7.siteCollectionData, _ref7$yextInfo = _ref7.yextInfo, yextInfo = _ref7$yextInfo === void 0 ? null : _ref7$yextInfo;
            if (!(yextInfo !== null)) {
              _context5.next = 3;
              break;
            }
            return _context5.abrupt("return", yextInfo);
          case 3:
            siteData = (siteCollectionData === null || siteCollectionData === void 0 ? void 0 : (_siteCollectionData$s = siteCollectionData.siteCollection) === null || _siteCollectionData$s === void 0 ? void 0 : (_siteCollectionData$s2 = _siteCollectionData$s.items) === null || _siteCollectionData$s2 === void 0 ? void 0 : _siteCollectionData$s2[0]) || {};
            contactInformation = getYextIdFromCurrentPage({
              path: path,
              combinedData: combinedData
            });
            mainYextId = getAllYextID(siteData);
            if (!((mainYextId === null || mainYextId === void 0 ? void 0 : mainYextId.length) === 0)) {
              _context5.next = 8;
              break;
            }
            return _context5.abrupt("return");
          case 8:
            _context5.next = 10;
            return getYextInfo(mainYextId);
          case 10:
            yextInfoData = _context5.sent;
            if (!contactInformation) {
              _context5.next = 13;
              break;
            }
            return _context5.abrupt("return", organizeYextInfoData({
              yextInfoData: yextInfoData,
              contactInformation: contactInformation
            }));
          case 13:
            return _context5.abrupt("return", yextInfoData);
          case 14:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return function getYext(_x9) {
    return _ref8.apply(this, arguments);
  };
}();
export var getYextDivision = function getYextDivision(yextInfo) {
  var _yextInfo$entities, _yextApiEntity$meta;
  // Some entities come with a different structure, thus the need for the following
  var yextApiEntity = (yextInfo === null || yextInfo === void 0 ? void 0 : (_yextInfo$entities = yextInfo.entities) === null || _yextInfo$entities === void 0 ? void 0 : _yextInfo$entities[0]) || yextInfo;
  var yextFolderIdData = (yextApiEntity === null || yextApiEntity === void 0 ? void 0 : (_yextApiEntity$meta = yextApiEntity.meta) === null || _yextApiEntity$meta === void 0 ? void 0 : _yextApiEntity$meta.folderId) || null;
  return yextFolderIdData;
};
export var getCountryCode = function getCountryCode(yextInfo) {
  var _yextInfo$entities2, _yextApiEntity$addres, _yextApiEntity$addres2;
  // Some entities come with a different structure, thus the need for the following
  var yextApiEntity = (yextInfo === null || yextInfo === void 0 ? void 0 : (_yextInfo$entities2 = yextInfo.entities) === null || _yextInfo$entities2 === void 0 ? void 0 : _yextInfo$entities2[0]) || yextInfo;
  return (yextApiEntity === null || yextApiEntity === void 0 ? void 0 : (_yextApiEntity$addres = yextApiEntity.address) === null || _yextApiEntity$addres === void 0 ? void 0 : (_yextApiEntity$addres2 = _yextApiEntity$addres.countryCode) === null || _yextApiEntity$addres2 === void 0 ? void 0 : _yextApiEntity$addres2.toLowerCase()) || null;
};